import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import WaiverService from './WaiverService';

interface WaiverAirlineListProps {
  canViewAllWaivers: () => boolean;
  updateIssuingAirlineCode: (code: string) => void;
}

const WaiverAirlineList: React.FC<WaiverAirlineListProps> = ({ canViewAllWaivers, updateIssuingAirlineCode }) => {
  const [issuingAirlineCodes, setIssuingAirlineCodes] = useState<string[]>([]);
  const [issuingAirlineCode, setIssuingAirlineCode] = useState<string>('');

  useEffect(() => {
    const loadIssuingAirlines = async () => {
      const response = await WaiverService.getAirlines();
      const airlines = _(response.data)
        .map((airline: string) => airline.toUpperCase())
        .sort()
        .uniq()
        .value();
      setIssuingAirlineCodes(['', ...airlines] as string[]);
    };

    loadIssuingAirlines();
  }, []);

  const onCodeUpdate = (issuingAirlineCode: string) => {
    setIssuingAirlineCode(issuingAirlineCode);
    updateIssuingAirlineCode(issuingAirlineCode);
  };

  return <>
    {canViewAllWaivers() && (
      <span className="waiver-header-link waiver-issue-airline">
        <form className="form-inline">
          <div className="form-group waiver-airline-list">
            <label htmlFor="airline">Filter By Issuing Airline</label>
            <select
              name="airline"
              id="airline"
              className="form-control form-control-sm"
              value={issuingAirlineCode}
              onChange={e => {
                onCodeUpdate(e.target.value);
              }}
            >
              {issuingAirlineCodes.map(airline => (
                <option key={airline} value={airline}>
                  {airline}
                </option>
              ))}
            </select>
          </div>
        </form>
      </span>
    )}
  </>;
};

export default WaiverAirlineList;